import AttachFileIcon from '@mui/icons-material/AttachFile';
import WSButton from '@common-components/ws-button/ws-button';
import { Stack } from '@mui/material';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';

interface MessageEditorAddAttachmentButtonProps {
  inputRef: RefObject<HTMLInputElement>;
}

export const MessageEditorAddAttachmentButton: React.FC<MessageEditorAddAttachmentButtonProps> = ({
  inputRef,
}) => {
  const { t } = useTranslation(namespace);
  return (
    <Stack direction='row'>
      <WSButton
        sx={{
          color: 'var(--color-text) !important',
          textTransform: 'none',
          letterSpacing: 0,
          fontWeight: 600,
          fontSize: '14px',
          // No inline-end margin: the parent toolbar Stack supplies the gap to the
          // Templates button. The 12px this used to add was pure surplus width, and
          // width is exactly what decides whether the toolbar wraps to two rows.
          // (It was already logical rather than physical, for RTL.)
          '& .MuiButtonBase-root.MuiButton-root.MuiButton-text': {
            color: 'var(--color-text) !important',
          },
        }}
        onClick={() => {
          if (inputRef?.current) {
            inputRef.current.click();
          }
        }}
      >
        <AttachFileIcon sx={{ fontSize: 18, color: 'var(--color-text)', marginInlineEnd: '5px' }} />
        {t('messageScheduling.addFiles')}
      </WSButton>
    </Stack>
  );
}; 